module.exports = __webpack_public_path__ + "static/media/guidance_background_mobile.215d4a75.png";